export default class LogoutManager {
    private static mRedirectUrl: string | null = null;
    private readonly logoutButton: HTMLButtonElement | null;
    private static readonly logoutMessageStorageKey: string = "performLogout";
    
    private static get redirectUrl(): string {
        if (!this.mRedirectUrl) {
            const script = document.getElementById("logout-manager-script");
            LogoutManager.mRedirectUrl = script?.getAttribute("data-redirect-after-logout-url") ?? "";
        }
        return this.mRedirectUrl ?? "";
    }

    constructor() {
        this.logoutButton = document.getElementById("logout-link") as HTMLButtonElement | null;
    }

    public static requiredScriptElementExists(): boolean {
        return document.getElementById("logout-manager-script") !== null;
    }
    
    public static init(redirectUrl: string): void {
        LogoutManager.mRedirectUrl = redirectUrl;
    }

    public appendEventListeners(): void {
        addEventListener("storage", (e) => {
            LogoutManager.receiveLogoutMessage(e);
        });

        this.logoutButton?.addEventListener("click", () => {
            LogoutManager.sendLogoutMessage();
        });
    }

    public static receiveLogoutMessage(e: StorageEvent): void {
        if (e.key === LogoutManager.logoutMessageStorageKey) {
            setTimeout(() => { // delay for ensuring, that logout was completed
                LogoutManager.redirect();
            }, 1000);
        }
    }

    public static sendLogoutMessage(): void {
        localStorage.setItem(this.logoutMessageStorageKey, Date.now().toString());
    }

    private static redirect(): void {
        window.location.href = encodeURI(this.redirectUrl);
    }
}
